<template>
    <div class="white-box white-box-no-tab">
        <TermsFrame
            :title="`${$route.meta.pageTitle}`"
            :subtitle="`為維護您的權益，線上申請信用卡授權，請詳細閱讀線上申請「續期信用卡授權約定條款」`"
            btn-text="本人已閱讀並同意"
            needLayer
            needGuideArrow
            :needBtn="isScrollToBottom"
            :content="content"
            :isLoading="isLoading"
            @isScrollToBottom="v => isScrollToBottom = v"
            @clickBtn="goNext"
        />
    </div>
</template>

<script>
import { ref, reactive } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { getAgreeTermsCreditCardAuth, postAgreeCreditCardAuth } from '@/apis/aplCatlCreditCardAuth.js';
import TermsFrame from '@/components/template/TermsFrame.vue';
import routeName from '@/router/constant.js';
import codeList from '@/json/codeList.js';

export default {
    components: {
        TermsFrame,
    },
    setup() {
        const router = useRouter();
        const content = ref('');
        const store = useStore();
        const isScrollToBottom = ref(false);
        const isLoading = ref(false);
        const getTerms = () => {
            getAgreeTermsCreditCardAuth().then(res => {
                if (res.data.agreeTerms) content.value = res.data.agreeTerms.content;
            });
        };
        getTerms();
        const goNext = () => {
            isLoading.value = true;
            postAgreeCreditCardAuth().then(() => {
                store.dispatch('services/setChangeItemsResult', { code: `${codeList.CREDIT_CARD_AUTH}cardInfo`, value: { ...cardInfoData() } });
                router.push({ name: routeName.CREDIT_CARD_AUTH_CARD_INFO });
            }).finally(() => {
                isLoading.value = false;
            });
        };

        const cardInfoData = () => {
            return reactive({
                cardBankName: '',
                cardBank: '',
                cardNo1: '',
                cardNo2: '',
                cardNo3: '',
                cardNo4: '',
                month: '',
                year: '',
                label: '',
            });
        };

        return { goNext, content, isLoading, isScrollToBottom };
    },
};
</script>
